import React from 'react';
import { IconButton, Menu, MenuItem, CircularProgress, ListItemIcon, ListItemText } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { RemediationValidationAdminRow } from '../../interfaces/questionnaire.interface';
import ExportDownloadMenuItem from './ExportDownloadMenuItem';
import { fetchRemediationValidationExport } from '../../services/assessments';

const VerificationActionsCell = ({ row, handleActionClick }: {
  row: RemediationValidationAdminRow,
  handleActionClick: (row: RemediationValidationAdminRow) => void;
}) => {
  const [showLoading, setShowLoading] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleStart = async () => {
    try {
      setShowLoading(true);
      await handleActionClick(row);
    } finally {
      setShowLoading(false);
      setAnchorEl(null);
    }
  };

  return (
      <>
        <IconButton size="small" onClick={handleMenuOpen}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
        <MenuItem onClick={handleStart} disabled={showLoading}>
          {showLoading && (
            <ListItemIcon sx={{ minWidth: 28 }}>
              <CircularProgress size={16} />
            </ListItemIcon>
          )}
          <ListItemText primary="Start Verification" />
        </MenuItem>
        <ExportDownloadMenuItem
          label="Download"
          fallbackFilename={`remediation-validation-${row.assessmentSurvey}.zip`}
          fetchExport={() => fetchRemediationValidationExport(row.assessmentSurvey)}
          onComplete={handleMenuClose}
        />
        </Menu>
      </>
  );
};

export default VerificationActionsCell;
  